import { render, staticRenderFns } from "./enroll-successtips.vue?vue&type=template&id=1a6c75bd&"
import script from "./enroll-successtips.vue?vue&type=script&lang=js&"
export * from "./enroll-successtips.vue?vue&type=script&lang=js&"
import style0 from "./enroll-successtips.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports